<template>
  <div class="common-meter" style="z-index: 666">
    <div v-resize="resizeChart" :id="meterId" style="margin: 0 auto;" :style="{width: width, height: height}"></div>
  </div>
</template>

<script>
  import {debounce} from "../../../utils/util"
  export default {
    name: 'common-meter',
    props: {
      meterId: {
        type: String,
        default () {
          return 'commonMeterId'
        }
      },
      width: {
        type: String,
        default () {
          return '100%'
        }
      },
      height: {
        type: String,
        default () {
          return '200px'
        }
      },
      series: {
        type: Array,
        default () {
          return []
        }
      }
    },
    data () {
      return {
        commonMeter: null
      }
    },
    mounted () {
      this.drawMeter()
      window.addEventListener('resize', this.resizeChart)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.resizeChart)
    },
    directives:{
      resize: { // 指令的名称
        bind(el, binding) { // el为绑定的元素，binding为绑定给指令的对象
          console.log(el,"绑定",binding);
          let width = '', height = '';
          function isReize() {
            const style = document.defaultView.getComputedStyle(el);
            if (width !== style.width || height !== style.height) {
              binding.value({width:style.width,height:style.height});  // 关键(这传入的是函数,所以执行此函数)
            }
            width = style.width;
            height = style.height;
          }
          el.__vueSetInterval__ = setInterval(isReize, 300);
        },
        unbind(el) {
          console.log(el,"解绑");
          clearInterval(el.__vueSetInterval__);
        }
      }
    },
    methods: {
      drawMeter() {
        let _self = this
        this.commonMeter = this.$echarts.init(document.getElementById(this.meterId))
        this.commonMeter.setOption({
          backgroundColor: 'transparent',
          tooltip: {
            formatter: '{a} <br/>{c} {b}'
          },
          series: this.series
        })
      },
      resizeChart: debounce(function () {
        this.commonMeter.resize()
      }, 100)
    },
    watch: {
      series (val) {
        this.drawMeter()
      },
      height (val) {
        this.drawMeter()
      }
    }
  }
</script>

<style scoped>
  .common-meter {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Echarts/Meter/commonMeter.vue